import {Frontend} from "./frontend";

(function () {
    XonBoard.FuelTankSensorReads = {
        list: {

            selectors: {
                sensor_reads_table: $('#sensor-reads-table'),
                count_label: $('#count-label'),
            },

            init: function (is_feed_tank) {

                let self = this;

                let columns = [
                    {data: 'received_date', name: 'sensor_reads.received_date', createdCell: self.renderCell,},
                    is_feed_tank ?     {data: 'status', name: 'sensor_reads.status'} : null,
                    {data: 'fuel_level', name: 'sensor_reads.values->fuel_level', createdCell: self.renderCell, sortable: false, searchable: false},
                    {data: 'to_fill', name: 'sensor_reads.values->to_fill', createdCell: self.renderCell, sortable: false, searchable: false},
                    {data: 'consumption', name: 'sensor_reads.consumption', createdCell: self.renderCell, sortable: false, searchable: false},
                    {data: 'ullage_1', name: 'sensor_reads.values->ullage', createdCell: self.renderCell},
                    {data: 'ullage_2', name: 'sensor_reads.values->ullage_2', createdCell: self.renderCell, sortable: false, searchable: false},
                    {data: 'src', name: 'sensor_reads.values->src', createdCell: self.renderCell,},
                    {data: 'srssi', name: 'sensor_reads.values->srssi', createdCell: self.renderCell},
                    {data: 'temperature', name: 'sensor_reads.temperature', createdCell: self.renderCell,},
                    {data: 'actions', name: 'actions', searchable: false, sortable: false, createdCell: self.renderCell,}
                ].filter((item) => item);


                let table = this.selectors.sensor_reads_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.sensor_reads_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsTotal);
                            return json.data;
                        },
                        data(d) {
                            const from_datetime = $('#from_datetime').val();
                            if (from_datetime) {
                                d.from_datetime = from_datetime;
                            }

                            const to_datetime = $('#to_datetime').val();
                            if (to_datetime) {
                                d.to_datetime = to_datetime;
                            }
                        },
                    },
                    columns: columns,
                    order: [[0, "desc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
            renderCell(td, cellData) {
                if(cellData && cellData.value != null) {
                    $(td).addClass(cellData.class);
                    $(td).html(cellData.value);
                    return;
                }

                $(td).html(cellData);
            }
        },
    }
})();
